import { render, staticRenderFns } from "./UserStatusModal.vue?vue&type=template&id=212d3c48&lang=html&"
import script from "./UserStatusModal.vue?vue&type=script&lang=js&"
export * from "./UserStatusModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports